import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Confirm } from 'src/app/utils/models';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: Confirm,
    private readonly matDialogRef: MatDialogRef<never>,
    private dialogRef: MatDialogRef<ConfirmComponent>
  ) {
    this.dialogRef.disableClose = true;
  }

  submit() {
    this.matDialogRef.close(true);
  }
}
